import { forIn } from "lodash";
import { EquipmentFunctionalityClass } from "./EquipmentFunctionalityClass";
import type { IrMap } from "./IrMap";

export class EquipmentFunctionalityClassFunctions {
    public static GetEquipmentFunctionalityClasses(): EquipmentFunctionalityClass[] {
        const equipmentFunctionalityClasses: EquipmentFunctionalityClass[] = [];
        forIn(EquipmentFunctionalityClass, (key) => {
            if (typeof key === "number") {
                equipmentFunctionalityClasses.push(key as any as EquipmentFunctionalityClass);
            }
        });
        return equipmentFunctionalityClasses;
    }

    public static GetEquipmentFunctionalityClassDictionary(): IrMap<EquipmentFunctionalityClass, string> {
        return EquipmentFunctionalityClassFunctions.GetEquipmentFunctionalityClasses().map((ec) => ({
            key: ec,
            value: EquipmentFunctionalityClass[ec],
        }));
    }
}
